import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { useI18N } from "../../context/I18NContext";
import { useSettings } from "../../context/SettingsContext";
import { useFlow } from "../../context/FlowContext";
import { useNavigate } from "react-router-dom";
import useWidgetStore from "../../store/useWidgetStore";
import useDataStore from "../../store/useDataStore";
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import CartSimple from "./CartSimple";
export default function CartSummary(props) {
    const { t, ts } = useI18N();
    const theme = useTheme();
    const navigate = useNavigate();
    const { booking, language, selectedCapacity, selectedCapacityGroups } = useWidgetStore();
    const { apptypes, resources } = useDataStore();
    const { staticData, showSelectedResource } = useSettings();
    const flow = useFlow();
    const [rows, setRows] = useState([]);
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    useEffect(() => {
        var _a;
        let _rows = [];
        if (booking.appointments) {
            let appointment = booking.appointments[0];
            _rows.push(dayjs(appointment.date).locale(language).format('dddd D MMMM HH:mm'));
            let component = appointment.components[0];
            let _apptypes = [];
            component.appointmentTypes.forEach((appointmentType_id) => {
                let appointmentType = apptypes.find((appointmentType) => appointmentType.id === appointmentType_id);
                if (appointmentType) {
                    _apptypes.push(appointmentType.name);
                }
            });
            if (_apptypes.length > 0) {
                _rows.push(_apptypes.join(', '));
            }
            if (showSelectedResource) {
                let _resources = [];
                component.resources.forEach((resource_id) => {
                    let resource = staticData === null || staticData === void 0 ? void 0 : staticData.resources.find((resource) => {
                        return resource.id === resource_id;
                    });
                    if (resource) {
                        _resources.push(resource.name);
                    }
                });
                if (_resources.length > 0) {
                    _rows.push(_resources.join(', '));
                }
            }
            if (selectedCapacity > 1) {
                if (selectedCapacityGroups[0]) {
                    _rows.push(ts('%capacity% personen', { capacity: selectedCapacity.toString() }, 'summary'));
                }
                else {
                    let parts = [];
                    const view = flow.views.find((view) => {
                        var _a;
                        const groups = (_a = view === null || view === void 0 ? void 0 : view.components) === null || _a === void 0 ? void 0 : _a.find((component) => {
                            if (component.picker === 'capacity') {
                                return component.config.groups;
                            }
                            return undefined;
                        });
                        return groups === null || groups === void 0 ? void 0 : groups.config.groups;
                    });
                    const groups = (_a = view === null || view === void 0 ? void 0 : view.components) === null || _a === void 0 ? void 0 : _a.find((component) => {
                        if (component.picker === 'capacity') {
                            return component.config.groups;
                        }
                        return undefined;
                    });
                    for (const [_key, _value] of Object.entries(selectedCapacityGroups)) {
                        if (_key !== '0' && _value > 0) {
                            let groupName = groups === null || groups === void 0 ? void 0 : groups.config.groups.find((group) => group.id === parseInt(_key)).name;
                            parts.push(ts('%capacity% %groupName%', { capacity: _value, groupName: t(groupName, 'select') }, 'summary'));
                        }
                    }
                    if (parts.length > 0) {
                        _rows.push(parts.join(', '));
                    }
                }
            }
            if (appointment.price > 0) {
                let price = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(appointment.price).replace(',00', ',-');
                _rows.push(ts('Prijs: %price%', { price: price }, 'summary'));
            }
        }
        setRows(_rows);
    }, [apptypes, resources, selectedCapacityGroups, selectedCapacity]);
    const goTo = (e) => {
        let target = e.target.closest('button');
        let path = target.getAttribute('rel');
        navigate(`/oa_widget_${path}`);
    };
    return (_jsxs(_Fragment, { children: [_jsx(TableContainer, { component: Paper, sx: {
                    marginBottom: (props === null || props === void 0 ? void 0 : props.cartSimple) ? 0 : 4,
                    borderRadius: (props === null || props === void 0 ? void 0 : props.cartSimple) ? '4px 4px 0 0' : '4px',
                }, children: _jsx(Table, { "aria-label": t('Jouw gegevens'), children: _jsx(TableBody, { sx: {
                            "& .MuiTableCell-body": {
                                fontSize: '1rem'
                            }
                        }, children: _jsxs(Fragment, { children: [_jsxs(TableRow, { sx: {
                                        backgroundColor: theme.palette.background.default
                                    }, children: [_jsx(TableCell, { colSpan: 3, children: rows === null || rows === void 0 ? void 0 : rows.map((row, i) => (_jsx(Box, { sx: Object.assign({ fontSize: '1.25rem' }, (i === 0 && {
                                                    fontWeight: 700
                                                })), children: row }, i))) }), isLarge && (_jsx(TableCell, { sx: { width: '2em' }, align: "right", children: _jsx(IconButton, { onClick: goTo, rel: 'index', "aria-label": "edit", size: "medium", children: _jsx(EditIcon, { sx: { color: theme.palette.text.secondary } }) }) }))] }), !isLarge && (_jsx(TableRow, { sx: {
                                        backgroundColor: theme.palette.background.default
                                    }, children: _jsx(TableCell, { colSpan: 3, sx: { padding: 0 }, children: _jsx(Button, { fullWidth: true, onClick: goTo, rel: 'index', sx: { marginBottom: 2 }, variant: "contained", color: "secondary", children: t('Gegevens wijzigen') }) }) }))] }) }) }) }), props.cartSimple && (_jsx(_Fragment, { children: _jsx(CartSimple, { cartSummary: true }) }))] }));
}
